
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  list: any[] = ['书法', '国画', '书画', '美育']
  active: string = '书法'

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
